import { Spin, message, Select, Space, Button, Popconfirm, Input } from "antd";
import React, { useEffect, useState } from "react";
import {
  CopyOutlined,
  DeleteOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import axios from "axios";
import API_HOST from "../config";

function SelectRemoteServer(props) {
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedItems, setSelectedItems] = useState('');
  const [options, setOptions] = useState([]);
  const [newName, setNewName] = useState('');

  useEffect(() => {
    let userName = localStorage.getItem('ga-userName');
    if(!userName) {
        let name = prompt("Nhập Tên Người Dùng: ");
        if(name) {
            userName = name;
            localStorage.setItem('ga-userName', name);
        } else {
          window.location.reload();
        }
    } else {
        let servers = localStorage.getItem('ga-servers')
        if(servers) {
            servers = JSON.parse(servers); // array
            // @ts-ignore
            setOptions(servers.map(s => {
                return {label: s, value: s};
            }))
        }
    }
  }, [])

  const addServer = () => {
    let servers = localStorage.getItem('ga-servers')
    if(!servers) {
        // @ts-ignore
        servers = [];
    } else {
        servers = JSON.parse(servers); // array
    }
    // @ts-ignore
    servers.push(newName);
    localStorage.setItem('ga-servers', JSON.stringify(servers));
    // @ts-ignore
    setOptions(servers.map(s => {
        return {label: s, value: s};
    }))
    setNewName('')
  }
  const remove = () => {
    let servers = localStorage.getItem('ga-servers')
    servers = JSON.parse(servers); // array
    // @ts-ignore
    servers = servers.filter(s => s != selectedItems);
    localStorage.setItem('ga-servers', JSON.stringify(servers));
    // @ts-ignore
    setOptions(servers.map(s => {
        return {label: s, value: s};
    }))
    setSelectedItems('')
  }

  const handleChange = (values) => {
    props.onSelected(values);
    setSelectedItems(values);
  };
  const oncopy = () => {
    let userName = localStorage.getItem('ga-userName');
    axios
      .post(`${API_HOST}/api/get-cmd-remote`, {userName, server: selectedItems})
      .then((res) => {
        navigator.clipboard.writeText(res.data);
        messageApi.info(`Đã copy mã: ${selectedItems}`);
      })
  }

  return (
    <div className="flex-space">
      {contextHolder}
      <div style={{width: 250}}>
        <label>Chọn Server: </label>
        <Select
          maxCount={1}
          value={selectedItems}
          allowClear
          style={{
            width: "150px",
            maxWidth: "350px"
          }}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          placeholder="Chọn Server..."
          onChange={handleChange}
          options={options}
          optionRender={option => (
            <div className="flex-between">
                <div>{option.data.label}</div>
                
            </div>
          )}
        />
      </div>
        {props.showAction && 
            <>
                <Popconfirm
                    style={{ width: 350 }}
                    placement="left"
                    okText="OK"
                    cancelText="Hủy"
                    title="Thêm Server:"
                    onConfirm={addServer}
                    description={
                    <>
                        <Input placeholder="Tên ..." value={newName} 
                            onChange={(e) => setNewName(e.target.value)} style={{width: 100}}/>
                    </>
                    }
                >
                    <Button type="primary"><PlusCircleOutlined /></Button>
                </Popconfirm>
                {selectedItems && 
                    <>
                        <Button onClick={oncopy}><CopyOutlined />Mã Setup</Button>
                        <Button danger onClick={remove}><DeleteOutlined /></Button>
                    </>
                }
            </>
        }
    </div>
  );
}
export default SelectRemoteServer;
